var render, staticRenderFns
import script from "./FristRow.vue?vue&type=script&lang=js&"
export * from "./FristRow.vue?vue&type=script&lang=js&"
import style0 from "./FristRow.vue?vue&type=style&index=0&id=15b71be0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports